import { useEffect } from 'react';
import DashboardHeader from './DashboardHeader';
import DashboardTabBar from './DashboardTabBar';
import TodayBlock from './blocks/TodayBlock';
import OutlookBlock from './blocks/OutlookBlock';
import NowBloomingCard from './blocks/NowBloomingCard';
import GardenStatsBlock from './blocks/GardenStatsBlock';
import CareModal from './CareModal';
import PflegekalenderView from './PflegekalenderView';
import { useDashboard } from '../../context/DashboardContext';

/**
 * DashboardView — Top-level shell for the Dashboard.
 *
 * Layout (full viewport):
 *   ┌──────────────────────────────┐
 *   │ DashboardHeader  (52px)      │
 *   ├──────────────────────────────┤
 *   │ DashboardTabBar  (48px)      │
 *   ├──────────────────────────────┤
 *   │ Content Area (flex-1)        │
 *   │  bg-gray-50                  │
 *   │                              │
 *   │  Tab: uebersicht             │
 *   │    [Block 1: Heute im Garten]│
 *   │    [Block 2: Blick nach vorn]│
 *   │    [Block 3: Dein Grünraum]  │
 *   │                              │
 *   │  Tab: pflegekalender         │
 *   │    [PflegekalenderView]      │
 *   └──────────────────────────────┘
 */
const DashboardView = () => {
  const { dashboardTab, mobileTab, setDashboardTab } = useDashboard();

  // Sync BottomTabBar selection → dashboardTab when on mobile
  useEffect(() => {
    if (mobileTab === 'pflegekalender') {
      setDashboardTab('pflegekalender');
    } else if (mobileTab === 'uebersicht') {
      setDashboardTab('uebersicht');
    }
  }, [mobileTab, setDashboardTab]);

  return (
    <div className="flex flex-col h-full w-full bg-gray-50">
      <DashboardHeader />
      <DashboardTabBar />

      <main className="flex-1 overflow-y-auto bg-gray-50">
        {dashboardTab === 'uebersicht' ? (
          <div className="max-w-[800px] mx-auto py-4 px-4 md:py-8 md:px-8 flex flex-col gap-4 md:gap-6">
            <TodayBlock />
            <OutlookBlock />
            <NowBloomingCard />
            <GardenStatsBlock />
          </div>
        ) : (
          <PflegekalenderView />
        )}
      </main>

      <CareModal />
    </div>
  );
};

export default DashboardView;
